"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./lib/index"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-color-picker/dist/index.js
// module id = ./node_modules/ngx-color-picker/dist/index.js
// module chunks = 3